import useBreakpointSync from "./useBreakpointSync";
import useUserAndEntriesSync from "./useUserAndEntriesSync";
import useFixPaymentAction from "./useFixPaymentAction";

const usePaymentDrawTonightInterface = () => {
  useBreakpointSync();
  useUserAndEntriesSync();
  useFixPaymentAction();
};

export default usePaymentDrawTonightInterface;
